import Vue from 'vue';

const success = (data, context) => {
  context.airbnbAccounts = data.airbnbAccounts;
  context.airbnbRentals = data.listings;
  context.airbnbAttachedRentalIds = data.airbnbAttachedRentalIds.map(attachedId => Number(attachedId));
  context.airbnbListingsLoading = false;

  if (data.listings) {
    if (data.authErrors) {
      let authErrors = data.authErrors;
      for(let error of authErrors) {
        toastr.error(context.$t('account.settings.user_platforms_section.airbnb_auth_error') + ' ' + error);
      }
    }
  }
};

const failed = (error, context) => {
  toastr.error(error.response.data.msg);
  context.airbnbAccounts = error.response.data.airbnbAccounts;
  context.airbnbRentals = error.response.data.listings;
  context.airbnbAttachedRentalIds = error.response.data.airbnbAttachedRentalIds;
  context.airbnbListingsLoading = false;
};

export default (context, rentalId = null, deviceID) => {
  return Vue.$http.get(`/get-airbnb-listings?rental_id=${rentalId}`).then((response) => {
    if (response && response.status === 200) {
      success(response.data, context);
    } else {
      failed(response, context);
    }
  })
  .catch((error) => {
    failed(error, context);
  });
};



// WEBPACK FOOTER //
// ./src/app/services/rental/getAirbnbListings.js